module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Regular-76093dba.eot";